import axios from 'axios'

export default {
  get: function () {
    return axios.get(`${process.env.WEB_ROOT}/geoip/`)
  }
}
